import MyPharmacy from './MyPharmacy'
export default MyPharmacy
